import { AvvirEvent } from "type_aliases";

export type ProcoreTradesLoadedEvent = AvvirEvent<typeof PROCORE_TRADES_LOADED, any>;

export const PROCORE_TRADES_LOADED = 'procore_trades_loaded';

const procoreTradesLoaded = (procoreTrades: any): ProcoreTradesLoadedEvent => ({
  type: PROCORE_TRADES_LOADED,
  payload: procoreTrades
});

export default procoreTradesLoaded;